/*
 * @Author: 小周
 * @Date: 2023-09-07 11:03:51
 * @LastEditTime: 2024-08-02 17:20:51
 * @LastEditors: MrZHLF
 * @Description:
 */

export function checkDevice() {
  // js判断是否是苹果设备
  function checkIsAppleDevice() {
    var u = navigator.userAgent
    // var app = navigator.appVersion
    var ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    var iPad = u.indexOf('iPad') > -1
    var iPhone = u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1
    if (ios || iPad || iPhone) {
      return true
    } else {
      return false
    }
  }
  if (checkIsAppleDevice()) {
    return 'IOS'
  } else {
    return 'Android'
  }
}

/**
 * @description 判断是否APP端或者H5端
 * @author 小周
 */
export function isCheckApp() {
  let photoType = checkDevice()
  if ('IOS' == photoType) {
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.requestShareUrl
    ) {
      return true
    } else {
      return false
    }
  } else {
    if (window.Android) {
      return true
    } else {
      return false
    }
  }
}

/**
 *
 * @description 判断设备
 * @author 小周
 */
export function getDevice() {
  let UA = window.navigator.userAgent.toLowerCase()
  let isIos = (UA && /iphone|ipad|ipod|ios/i.test(UA)) || false
  let isAndroid = (UA && /(android)/i.test(UA)) || false
  let isWechat = (UA && /MicroMessenger/i.test(UA)) || false

  if (isIos) {
    return isWechat ? ['ios', 'wechat'] : ['ios']
  } else if (isAndroid) {
    return isWechat ? ['android', 'wechat'] : ['android']
  } else {
    return isWechat ? ['other', 'wechat'] : ['other']
  }
}

/**
 * @author 小周先生
 * @description 平台判断
 */
export function getBrowserEnvironment() {
  const userAgent = navigator.userAgent.toLowerCase()

  if (
    userAgent.includes('aweme') ||
    userAgent.includes('douyin') ||
    userAgent.includes('didi')
  ) {
    //抖音
    return 'DYshare'
  } else if (userAgent.includes('micromessenger')) {
    //微信
    return 'WXShare'
  } else if (userAgent.includes('weibo')) {
    //微博
    return 'XLShare'
  } else if (
    userAgent.includes('toutiao') ||
    userAgent.includes('newsarticle') ||
    userAgent.includes('ttwebview')
  ) {
    //头条
    return 'TTShare'
  } else if (userAgent.includes('bili')) {
    //哔哩哔哩
    return 'Bili'
  } else if (userAgent.includes('kswebview')) {
    //快手
    return 'KSShare'
  } else {
    return ''
  }
}

/**
 * @author 小周先生
 * @param {Object} data 数据对象
 * @description 获取封面图
 * @returns
 */
export function coverImage(data) {
  let res = ''
  if (data.coverImagesList && data.coverImagesList.length > 0) {
    data.coverImagesList.forEach((item) => {
      if (!item.coverBool) {
        res = item.url
      } else if (data.coverImagesList >= 1) {
        res = data.coverImagesList[1].url
      }
    })
  } else {
    res = 'https://res.hntv.tv/icon/dxdefault.jpg'
  }
  return res
}
